import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['fetchDirectory']),

    async initData(id) {
      const { S3Path, directoryKey } = id
      await this.fetchDirectory({ S3Path, directoryKey })
    },
  },
}
